module Meevo.Plugins.CancellationReasons {
  "use strict";

  /**
  * Main Section of Client 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.CancellationType> {

    /**
  * Base class override which defines what a DEFAULT model looks like.
  */
    createSectionModelInstance(postAdd:(data:any)=>any): void {
      this.dataService.getTemplate(this.baseEndpoint).then((data) => {
        this.model = data;
      });
    }

  }
}